import React from 'react';

import ContactsIcon from '@mui/icons-material/Contacts';

import RelatedListCard from '../RelatedListCard';
import RelatedTileGrid from '../RelatedTileGrid';
import { accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';
import { useAccountRelatedPreview } from '../useAccountRelatedRows';

import AccountContactTile from './AccountContactTile';
import { toAccountContact } from './toAccountContact';

interface Props {
  accountId: string;
}

export default function AccountContactsCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { count, error, isLoading, rows: contacts } = useAccountRelatedPreview(accountId, 'contacts', toAccountContact);

  return (
    <RelatedListCard
      count={count}
      error={error}
      icon={<ContactsIcon color="action" />}
      isLoading={isLoading}
      title="Contacts"
      viewAllTo={accountPath(accountId, offerId, '/contacts')}
    >
      <RelatedTileGrid>
        {contacts.map((contact) => (
          <AccountContactTile key={contact.id} contact={contact} />
        ))}
      </RelatedTileGrid>
    </RelatedListCard>
  );
}
